/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { File_ } from "./File_";
export const FileResponse = core.serialization.object({
    data: File_,
});
